<template>
  <div class="commentaries-window-component">
    <h1 class="window-title font-weight-regular">
      Коментарии:
    </h1>
    <!-- button-group: общие правила кнопок подтверждения и возврата (App.vue) -->
    <div class="button-group-section button-group">
      <v-row dense class="justify-space-between">
        <v-col sm="5">
          <v-btn
            @click="back"
            class="button button-back"
            width="100%"
            color="#F1F3F6"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5">
          <v-btn
            @click="saveComments"
            class="button button-green button-color-white"
            width="100%"
            color="#F1F3F6"
            :loading="isLoading"
          >
            <font-awesome-icon icon="check" />
            Применить
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="button-group-section comment-tabs">
      <v-row dense class="justify-space-between">
        <v-col sm="12">
          <v-btn-toggle class="fullwidth" v-model="currentTab" dense group mandatory>
            <!-- Комментарий курьеру есть и в сайдбаре, но там он виден только на
                 шагах адреса и оплаты, а на компактном десктопе свёрнут вместе с ним -->
            <v-btn value="courier" class="button">
              Для курьера
            </v-btn>
            <v-btn value="kitchen" class="button" >
              Для кухни
            </v-btn>
            <v-btn value="basket" class="button" >
              Для сборки
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </div>

    <div v-if="currentTab === 'courier'" class="basket-comment-section">
      <span class="label">Комментарий для курьера</span>
      <v-textarea
        :value="courierComment"
        color="#000000"
        placeholder="Введите комментарий"
        class="textarea"
        solo
        flat
        height="370px"
        no-resize
        hide-details="auto"
        @input="onCourierInput"
      />
    </div>

    <div v-if="currentTab === 'kitchen'" class="basket-comment-section">
      <span class="label">Комментарий для кухни</span>
      <v-textarea
        v-model="kitchenComment"
        @focus="showKitchenKeyboard = true"
        color="#000000"
        placeholder="Введите комментарий"
        class="textarea"
        solo
        flat
        height="370px"
        no-resize
        hide-details="auto"
      />
    </div>

    <div v-if="currentTab === 'basket'" class="basket-comment-section">
      <span class="label">Комментарий для сборки</span>
      <v-textarea
        v-model="assemblyComment"
        @focus="showBasketKeyboard = true"
        color="#000000"
        placeholder="Введите комментарий"
        class="textarea"
        solo
        flat
        height="370px"
        no-resize
        hide-details="auto"
      />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'CommentariesWindow',
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        currentTab: 'courier',
        showKitchenKeyboard: false,
        showBasketKeyboard: false,
        isLoading: false,
        kitchenComment: '',
        assemblyComment: '',
        courierComment: '',
        // значения из корзины, от которых отсчитываются правки в окне
        saved: {
          courier: '',
          kitchen: '',
          assembly: '',
        },
      }
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
      // три комментария так, как они сейчас лежат в корзине
      basketComments () {
        return {
          courier: this.basket.commentForCourier || '',
          kitchen: this.basket.kitchenComment || '',
          assembly: this.basket.comment || '',
        }
      },
    },
    watch: {
      // Корзина меняется и мимо окна: комментарий курьеру в сайдбаре сохраняется
      // сам, а бэкенд тут же переливает его в кухонный и сборочный. Пока окно
      // сохраняет само, поля сверяет saveComments
      basketComments (actual) {
        if (!this.isLoading) {
          this.followBasket(actual)
        }
      },
    },
    methods: {
      // Поля, которые в окне не меняли, показывают то, что сейчас в корзине.
      // Изменённые не трогаем: в них намерение пользователя
      followBasket (actual) {
        if (this.courierComment === this.saved.courier) {
          this.courierComment = actual.courier
        }
        if (this.kitchenComment === this.saved.kitchen) {
          this.kitchenComment = actual.kitchen
        }
        if (this.assemblyComment === this.saved.assembly) {
          this.assemblyComment = actual.assembly
        }
        this.saved = actual
      },
      // То же правило, что на бэкенде (BasketObserver::syncComments): комментарий
      // курьеру переливается в кухонный и сборочный, пока те с ним совпадают,
      // то есть отдельно не правились. В окне это видно сразу, до сохранения
      onCourierInput (value) {
        const text = value || ''
        const previous = this.courierComment

        this.courierComment = text
        if (this.kitchenComment === previous) {
          this.kitchenComment = text
        }
        if (this.assemblyComment === previous) {
          this.assemblyComment = text
        }
      },
      back () {
        this.$store.commit('newOrder/setCurrentOtherWindow', undefined)
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
      },
      async saveComments () {
        const id = this.basket.id
        // что должно получиться: поля окна на момент нажатия
        const courier = this.courierComment
        const kitchen = this.kitchenComment
        const assembly = this.assemblyComment
        const saved = this.saved

        this.isLoading = true

        try {
          // Комментарий курьеру лежит в корзине отдельным полем и сохраняется своим
          // запросом. Сначала он: бэкенд при этом сам переливает текст в кухонный
          // и сборочный, если их не правили вручную
          if (courier !== saved.courier) {
            await this.$store.dispatch('baskets/updateCommentForCourier', {
              value: courier,
              id,
            })
          }

          // Кухонный и сборочный отправляем, только если поле меняли в окне и после
          // перелива оно всё ещё отличается. Любое присланное отличие бэкенд считает
          // ручной правкой и перелив в это поле отключает навсегда - поэтому
          // нетронутые поля слать нельзя: в них значения до перелива
          const actual = this.basketComments
          const data = {}
          if (kitchen !== saved.kitchen && kitchen !== actual.kitchen) {
            data.kitchenComment = kitchen
          }
          if (assembly !== saved.assembly && assembly !== actual.assembly) {
            data.comment = assembly
          }

          if (Object.keys(data).length) {
            const res = await this.$store.dispatch('baskets/updateComments', { data, id })
            if (res.status !== 200) {
              this.showErrorMessage(res.response.data.message)
              return
            }
          }

          this.showSuccessMessage('Комментарии обновлены')
          this.$store.dispatch('baskets/fetchSingleBasket', id)
          this.back()
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.isLoading = false
          // окно осталось открытым после ошибки: нетронутые поля догоняют то, что
          // уже сохранилось
          this.followBasket(this.basketComments)
        }
      },
    },
    mounted () {
      const actual = this.basketComments

      this.courierComment = actual.courier
      this.kitchenComment = actual.kitchen
      this.assemblyComment = actual.assembly
      this.saved = actual
    },
  }
</script>

<style lang="less" scoped>
.commentaries-window-component {
  .window-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 32px;
  }

  .label {
    display: block;
    margin-bottom: 16px;
    font-size: 20px;
    line-height: 21px;
  }

  .textarea {
    ::v-deep {
      &.v-input__slot {
        border-radius: 15px;
        background-color: @color-secondary;
      }
    }
  }

  .button {
    height: 80px;
    background-color: @color-secondary;
    font-size: 15px;
    box-shadow: 0 3px 6px #00000029 !important;
    border-radius: 10px !important;
    font-weight: 500;

    &.v-item--active {
      background-color: @color-primary !important;
      color: #ffffff;
    }

    &:before {
      display: none;
    }

    svg {
      margin-right: 8px;
    }

    &.button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }
  }

  .button-group-section {
    margin-bottom: 24px;

    ::v-deep {
      .v-btn {
        flex-grow: 1;
      }
    }
  }

  // Вкладок три, блок на всю ширину окна, кнопки не шире 160px
  .comment-tabs .button {
    max-width: 160px;

    // компактный десктоп: высота как у кнопок подтверждения и возврата
    .media-compact-pc({
      height: 65px;
    });
  }

  ::v-deep {
    .ps__rail-y {
      opacity: 0.5;
    }
  }
}
</style>
